import { render } from "./socialHeader.vue?vue&type=template&id=6a4fe892&scoped=true&ts=true"
import script from "./socialHeader.vue?vue&type=script&lang=ts"
export * from "./socialHeader.vue?vue&type=script&lang=ts"

import "./socialHeader.vue?vue&type=style&index=0&id=6a4fe892&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4fe892"]])

export default __exports__